import React, { useEffect, useState } from "react";
import LoanDetailsCard from "./sub-components/LoanDetailsCard";

function LoanDetails({ data }) {
  console.log(data);

  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (data?.history?.length) {
      setHistory(data?.history);
    }
  }, [data]);

  return (
    <div className="w-11/12 mx-auto  border border-gray-200 rounded-lg mt-6 bg-white dark:bg-[#060d26] shadow-sm p-4">
      <h3 class="mb-4 mt-2 text-lg font-medium leading-none text-gray-900 dark:text-white">
        جزئیات وام {data?.user?.name}
      </h3>

      <div className="mt-8 flex flex-col gap-6">
        {history?.length ? (
          history.map((item) => {
            return <LoanDetailsCard data={item} />;
          })
        ) : (
          <div className="shadow rounded-lg py-12 flex items-center justify-center text-gray-500">
            <p>هیچ ویرایشی روی وام صورت نگرفته است.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoanDetails;
